module.exports = __webpack_public_path__ + "media/images/emblems/Leuk_VS-5c3a604bc94b201673626bdbad6fb417.gif";